import styles from '@/styles/category/category-filter.module.scss'

// 定义分类项接口
interface cateFilterItem {
  name: string;
  categoryID: number | string;
  url: string;
  subCategories?: cateFilterItem[];
}

interface cateFilterDataItem {
  title: string;
  key: string;
  currentCategoryId?: string | number;
  items: cateFilterItem[]
}

interface Props {
  onlyFirstLevelCategory?: boolean; // 仅展示一级分类
  cateFilterData: cateFilterDataItem[];
  onSelectCategory: (_categoryItem: cateFilterItem) => void; // 通知父组件 请求接口修改数据
}

export default function CategoryFilter({ onlyFirstLevelCategory, cateFilterData, onSelectCategory }: Props) {
  // 点击事件
  const handleSelectCategory = (item: cateFilterItem) => {
    // 如果提供了回调函数，则通知父组件
    if (onSelectCategory) {
      onSelectCategory(item)
    }
  };

  return (
    <div className={styles['comp-category-filter']}>
      {
        cateFilterData.map((item: cateFilterDataItem) => (
          <div className={styles['filter-title']} key={item.key}>
            {item.title}

            {/* 一级分类 */}
            {
              item.items.map((cateFirstLevel: cateFilterItem) => (
                <div className={styles['category-first-level']} key={cateFirstLevel.categoryID}>
                  <div 
                    className={styles['first-level']}
                  >
                    <div
                      className={`
                        ${styles['first-level-name']}
                        ${cateFirstLevel.categoryID == item.currentCategoryId ? styles['selected'] : ''}
                        ${onlyFirstLevelCategory ? styles['only-first-level'] : ''}
                      `}
                      onClick={() => handleSelectCategory(cateFirstLevel)}
                    >{cateFirstLevel.name}</div>
                  </div>

                  {/* 二级分类 */}
                  {
                    !!(!onlyFirstLevelCategory && cateFirstLevel.subCategories && cateFirstLevel.subCategories.length) &&
                    cateFirstLevel.subCategories.map((cateSecondLevel: cateFilterItem) => (
                      <div className={styles['second-level']} key={cateSecondLevel.categoryID}>
                        <div 
                          className={styles['second-level-box']}
                          style={ cateSecondLevel.subCategories && cateSecondLevel.subCategories.length ? undefined : { paddingLeft: '16px' } }
                        > 
                          <div className={styles['second-level-name-box']}>
                            <div
                              className={`
                                ${styles['second-level-name-text']} 
                                ${cateSecondLevel.categoryID == item.currentCategoryId ? styles['selected'] : ''}
                              `}
                              onClick={() => handleSelectCategory(cateSecondLevel)}
                            >{cateSecondLevel.name}</div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            }
          </div>
        ))
      }
    </div>
  )
}